if($('#install-questionnaire-app').length > 0) {
    
    var langNum = 0;
    if ( $('html').attr('lang') == 'fr' ) {
        langNum = 1;
    } 

    var questionsQueue = [];
    var breadcrumbs = [0];
    var price_zone = "ZBD";

    var productsLibrary = {};
    var waitingList = {};

    var question;
    var questionnaire = {};
    var install_skus = {};
    var selectedAnswer;

    let currentPage = "main-page";
    let productType = ""
    const searchResultsEl = document.getElementById('searchBySkuResults');

    $(document).ready(function () {

        $( window ).on("load", function() {
            
            if($('body').attr('data-price')) {
                price_zone = $('body').attr('data-price');
            }

            // get all
            
        });


        $('.single-app').click(function() {

            
            
            if(currentPage === "main-page") {
                let singleAppThumb = $(this).find('.img-wrapper').clone();
                $('.breadcrumbs .current-appliance').empty();
                $('.breadcrumbs .current-appliance').append(singleAppThumb);
            }

            productType = $(this).attr('data-app');

            if(productType === "search-sku") {

                $('.search-sku-modal').fadeIn('200');
                $('.overlay').fadeIn('200');
                $('.search-sku-product').empty();
                $('#searchBySkuResults').empty();
                $('.search-sku-form input').val("");
                

            } else {
                if(currentPage === "main-page") {
                    $('.main-page').fadeOut('200', function() {
    
                        if($('.appliance-type-page > div[data-app=' +  productType + ']').length > 0) {
                            $('.appliance-type-page').fadeIn('200');
                            $('.appliance-type-page > div[data-app=' +  productType + ']').fadeIn('200');
                            currentPage = "appliance-type-page";
                        } else {
                            $('.question-page').fadeIn('200');
                            currentPage = "question-page";
                        }
    
                        $('.start-over-btn').fadeIn('200');
                        $('.breadcrumbs').fadeIn('200');
                    });
                }

                if(currentPage === "appliance-type-page") {
                    $('.appliance-type-page').fadeOut('200', function() {
                            $('.question-page').fadeIn('200');
                            currentPage = "question-page";
                    });
                }

                getQuestions(productType)
                
            }   
        });

        var searchSKU = '';
       

        $(document).on("keypress", "#searchBySkuInput", function (e) {
            if ( e.key == "Enter") {
                searchSKU = $('#searchBySkuInput').val();
                if ( searchSKU !== '' ) {
                    getProductBySKU(searchSKU);
                }
            }
        });

        $("#searchBySku").click(function() {
            searchSKU = $('#searchBySkuInput').val();
            if ( searchSKU !== '' ) {
                getProductBySKU(searchSKU);
            }
        });

    });

    function getQuestions(productType) {
        var product_page = '/pages/product-json-pdp-install?type=' + productType + '&zone=' + price_zone;

                getJSONCached(product_page, '', function(product) {
                    try {
                        product = $.parseJSON(product);
                    } catch (e) {
                        return false;
                    }

                    var productTypeText = "";

                    if(langNum == 0) {
                        productTypeText = (product.product_type).split("|")[0];
                    } else {
                        productTypeText = (product.product_type).split("|")[1];
                    }

                    $('.question-page .question-header .product-type-text').text(productTypeText);
                        
                    questionnaire = product.questions;
                    install_skus = product.install_skus;

                    populateQuestion(questionnaire[0], productType);

                }); 
    }

    function populateQuestion(questionObj, productType) {

        question = questionObj;
        var id = questionObj.id;
        
        var choicesHTML = "";

        var choicesArr = questionObj.choices;

        $('.question-choices').show();
        $('.result-main').hide();
        $('.answers-summary').hide();

        $(".question-choices input[type='radio']").prop('checked',false);

        if ($(".question-choices input[type='radio']:checked").length <=0 && !question.isResult) {
            disableNext(); 
        }

        if(langNum == 0) {
            $('.question-main .question-text').text(questionObj.text_en);
        } else {
            $('.question-main .question-text').text(questionObj.text_fr);
        }
            
        for(var i = 0; i < choicesArr.length; i++) {
            var choiceText = "";

            if(langNum == 0) {
                choiceText =  choicesArr[i].text_en;
            } else {
                choiceText =  choicesArr[i].text_fr;
            }

            var noteText = "";

            if(choicesArr[i].note_en != "" && choicesArr[i].note_en != null ) {
                if(langNum == 0) {
                    noteText =  choicesArr[i].note_en;
                } else {
                    noteText =  choicesArr[i].note_fr;
                }
            }

            choicesHTML+='<div class="choice-item">';
            choicesHTML+='<input type="radio" id="choice-' + (choiceText).toLowerCase() +'" name="choice-item" value="' + choicesArr[i].value + '" go-to="' + choicesArr[i].goto + '" note-text="' + noteText +'">';
            choicesHTML+='<label for="choice-' + (choiceText).toLowerCase() +'">' + choiceText + '</label><br>';
            choicesHTML+='</div>';
        }
        
        // special note for fridges
        if((productType == "refrigerator-built-in" || productType == "refrigerator-built-in-dropship" || productType == "refrigerator-external" || productType == "refrigerator-external-dropship")  && id == 11) {
            $('.question-choices').html("");
        } else {
            $('.question-choices').html(choicesHTML);
        }

        $('#currentQstn').val(id);

        if($('#currentQstn').val() == "1") {
            $('.question-nav .back').css("opacity", "0");
            $('.question-nav .back').css("cursor", "default");
            $('.question-nav .back').css("pointer-events", "none");
        } else {
            $('.question-nav .back').css("opacity", "1");
            $('.question-nav .back').css("cursor", "pointer");
            $('.question-nav .back').css("pointer-events", "auto");
        } 

        $('.install-modal-question').fadeIn();
    }


    $(document).on('change', '.question-choices input[type=radio]', function() {
        if ($(".question-choices input[type='radio']:checked").length && !question.isResult) {

            var selectedChoice = $(".question-choices input[type='radio']:checked");
            selectedAnswer = $(selectedChoice).val();
            
            enableNext(); 
        }
    });

    function enableNext() {
        $('.question-nav .next').css("opacity", "1");
        $('.question-nav .next').css("cursor", "pointer");
        $('.question-nav .next p').css("color", "#282828"); 
        $('.question-nav .next svg path').css("fill", "#282828");
    }

    function disableNext() {
        $('.question-nav .next').css("cursor", "default");
        $('.question-nav .next p').css("color", "#e5e5e5"); 
        $('.question-nav .next svg path').css("fill", "#e5e5e5"); 
    }

    function hideNext() {
        $('.question-nav .next').css("opacity", "0");
    }

    $('.question-nav .next').click(function(e) {

        if((productType == "refrigerator-built-in" || productType == "refrigerator-built-in-dropship" || productType == "refrigerator-external" || productType == "refrigerator-external-dropship") && $('#currentQstn').val() == "11") {
            var nextQuestionObj = questionnaire.find(({id}) => id == 9);
            // questionsQueue.push( {question_id: nextQuestionObj.id, answer: 1});
            populateQuestion(nextQuestionObj);
            disableNext();
        }

        // push current question
        questionsQueue.push( {question_id: parseInt($('#currentQstn').val()), answer: parseInt(selectedAnswer)}); 

        if ($(".question-choices input[type='radio']:checked").length) {

            var selectedChoice = $(".question-choices input[type='radio']:checked");

            if(isNaN((selectedChoice).attr("go-to")) || (selectedChoice).attr("go-to").includes("-")) {

                var resultSKUObj = install_skus.find(({id}) => id == (selectedChoice).attr("go-to"));
                showResult(resultSKUObj, selectedChoice.attr("note-text"));

            } else {

                var nextQuestionObj = questionnaire.find(({id}) => id == (selectedChoice).attr("go-to"));

                populateQuestion(nextQuestionObj);

                if((productType == "refrigerator-built-in" || productType == "refrigerator-built-in-dropship" || productType == "refrigerator-external" || productType == "refrigerator-external-dropship") && nextQuestionObj.id == 11) {
                    enableNext();
                } else {
                    disableNext();
                }
            }
        }


    })

    $('.question-nav .back').click(function(e) {


        var lastQuestionID = questionsQueue[questionsQueue.length - 1].question_id;
        var lastQuestionObj = questionnaire.find(({id}) => id == lastQuestionID);

        populateQuestion(lastQuestionObj);
        questionsQueue.pop();
 
    });

    $(document).on('click', '.answers-list .answer-single', function() {

        var questionId = $(this).attr('data-question-id');

        var goBackToQuestion = questionnaire.find(({id}) => id == questionId);
        populateQuestion(goBackToQuestion);

        const index = questionsQueue.findIndex(question => question.question_id >= questionId);
        if (index !== -1) {
            questionsQueue.splice(index);
        }
    });

    // Search SKU selected product
    $(document).on('click', '.searchProd', function() {

        var productType = $(this).attr('data-install-type').toLowerCase().replaceAll(" ","-");

        

        getQuestions(productType);

        $('.main-page').fadeOut('200');
        $('.question-page').fadeIn('200');
        $('.overlay').fadeOut('200');
        $('.search-sku-modal').hide();
        $('.start-over-btn').fadeIn('200');
        $('.breadcrumbs').fadeIn('200');

        $('.search-sku-product').show();
        $(this).clone().appendTo('.search-sku-product');

        $('.search-sku-form input').val('');
        $('#searchBySkuResults').empty();
        
        currentPage = "question-page";
    });

    // Breadcrumsb - Home Icon
    $(document).on('click', '.breadcrumbs .home-icon', function() {
        
        if(currentPage === "appliance-type-page") {
            $('.appliance-type-page').fadeOut('200', function() {
                $('.main-page').fadeIn('200');
                $('.appliance-type-page > div').hide();
            });
            
            $('.breadcrumbs').fadeOut('200', function() {
                $('.breadcrumbs .current-appliance').empty();
            });
    
            $('.start-over-btn').fadeOut('200');
            
            currentPage = "main-page";
        } else {
            $('.start-over-modal').fadeIn('200');
            $('.overlay').fadeIn('200');
        }
        
    });

    // Breadcrumsb - Start Over
    $(document).on('click', '.start-over-btn', function() {

        if(currentPage === "appliance-type-page") {
            $('.appliance-type-page').fadeOut('200', function() {
                $('.main-page').fadeIn('200');
                $('.appliance-type-page > div').hide();
            });
            
            $('.breadcrumbs').fadeOut('200', function() {
                $('.breadcrumbs .current-appliance').empty();
            });
    
            $('.start-over-btn').fadeOut('200');
            
            currentPage = "main-page";

        } else {

            $('.start-over-modal').fadeIn('200');
            $('.overlay').fadeIn('200');

            $('#searchBySkuResults').empty();
            $('.search-sku-product').empty();
            $('.search-sku-form input').val('');
        }

    });

    // Breadcrumsb - Start Over - Yes
    $(document).on('click', '.start-over-yes', function() {

        $('.start-over-modal').fadeOut('200', function() {
            $('.overlay').fadeOut('200');
        });

        if(currentPage === "question-page") {

            $('.question-page').fadeOut('200', function() {
                $('.main-page').fadeIn('200');
                $('.question-main .question-text').empty();
                $('.question-main .question-choices').empty();
                $('.question-main .result-main').empty();
                $('.search-sku-product').hide();
            });
        }

        if(currentPage === "appliance-type-page") {
            $('.appliance-type-page').fadeOut('200', function() {
                $('.main-page').fadeIn('200');
            });
        }

        $('.breadcrumbs').fadeOut('200', function() {
            $('.breadcrumbs .current-appliance').empty();
        });

        $('.start-over-btn').fadeOut('200');
        $('.appliance-type-page > div').hide();

        currentPage = "main-page";
        questionsQueue = [];
    
    });

    // Breadcrumsb - Start Over - No
    $(document).on('click', '.start-over-no', function() {

        $('.start-over-modal').fadeOut('200');
        $('.overlay').fadeOut('200');
        
    });

    $(document).on('click', '.close-search-sku', function() {

        $('.search-sku-modal').fadeOut('200');
        $('.overlay').fadeOut('200');
        
    });

    $(document).on('click', '.overlay', function() {

        if( $('.overlay').is(":visible")) {
            $('.search-sku-modal').fadeOut('200');
            $('.start-over-modal').fadeOut('200');
            $('.overlay').fadeOut('200');
        }
    });

    $('body').on('click', '.langChange', function(){
		var urlLocation = window.location.pathname + window.location.search;
		if ( $('html').attr('lang') == 'en' ) {
			window.location = 'https://www.brickenligne.com' + urlLocation;
		} else {
			window.location = 'https://thabrick.com' + urlLocation;
		}
    });


    function showResult(resultSKU, noteText) {
        
        var answersHTML = "<ul>";


        questionsQueue.forEach((obj) => {

            const matchingObject = questionnaire.find(({id}) => id === obj.question_id);

            if(langNum == 0) {
                answersHTML+='<li class="answer-single" data-question-id="' + obj.question_id + '"><div><div class="update-btn"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"/></svg></div><span>' + matchingObject.text_en + '</span></div><span>' + (obj.answer === 1 ? 'Yes' : 'No') + '</span></li>';
            } else {
                answersHTML+='<li class="answer-single" data-question-id="' + obj.question_id + '"><div><div class="update-btn"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"/></svg></div><span>' + matchingObject.text_fr + '</span></div><span>' + (obj.answer === 1 ? 'Oui' : 'Non') + '</span></li>';
            }

          });

        answersHTML+='</ul>';

        $('.result-main').show();

        if(resultSKU.id != "CONTACT") {
            if(langNum == 0) {
                $('.question-text').text("Recommended Service: ");
            } else {
                $('.question-text').text("Service recommandé : ");
            }
        } else {
            if(langNum == 0) {
                $('.question-text').text("Note: ");
            } else {
                $('.question-text').text("Remarque : ");
            }
            
        }

        var choicesHTML = "";
        var title = "";
        var price = 0;
        var titleText = "";

        if(resultSKU.sku.length > 1) {

            for(var i = 0; i < resultSKU.sku.length; i++) {

                if(langNum == 0) {
                    titleText = resultSKU.sku[i].title_en;
                } else {
                    titleText = resultSKU.sku[i].title_fr;
                }

                title+='<div class="sku-result-single" data-price="' + resultSKU.sku[i].price + '" data-text="' + titleText + '" data-variant-id="' + resultSKU.sku[i].variant_id +'"><p>' + titleText + " - " + resultSKU.sku[i].sku_text + "</p><p>" + formatCurrency(resultSKU.sku[i].price / 100) + "</p>" + '</div>';
                price+=resultSKU.sku[i].price;
            }
        } else {

            if(langNum == 0) {
                titleText = resultSKU.sku[0].title_en;
            } else {
                titleText = resultSKU.sku[0].title_fr;
            }

            if(resultSKU.id == "CONTACT") { 
                if(langNum == 0) {
                    title = '<p class="contact-brick">' + titleText.replace("contact", "<a href=\"/pages/contact-us\" target=\"_blank\">contact</a>") + '</p>';
                } else {
                    title = '<p class="contact-brick">' + titleText.replace("contacter", "<a href=\"/pages/contact-us\" target=\"_blank\">contact</a>") + '</p>';
                }
                price = "";
            } else {
                title = '<div class="sku-result-single" data-price="' + resultSKU.sku[0].price + '" data-text="' + titleText + '" data-variant-id="' + resultSKU.sku[0].variant_id +'"><p>' + titleText + " - " + resultSKU.sku[0].sku_text + "</p><p>" + formatCurrency(resultSKU.sku[0].price / 100) + '</p></div>';
                price = resultSKU.sku[0].price;
            }

        }

        choicesHTML+='<div class="choice-item" data-price="' + price + '">';
        choicesHTML+='<div class="sku-result-container">';
        choicesHTML+='<div class="sku-result-title">';
        choicesHTML+=title;
        choicesHTML+='</div>'; 

        if(resultSKU.id != "CONTACT") {
            choicesHTML+='<div class="total-price-sku">';
            choicesHTML+='<h2>Total:</h2>';
            if (langNum == 0) {
                choicesHTML+='<h2>' + formatCurrency(price / 100) + '</h2>';
            } else {
                choicesHTML+='<h2>' + (formatCurrency(price / 100).replace(',',' ').replace('.',',').replace('$ ','')) + '</h2>';
            }
            choicesHTML+='</div>';
            
            choicesHTML+='</div>';
    
            if(noteText != "" && noteText != null) {
                if (langNum == 0) {
                    choicesHTML+='<div style="font-style: italic">* ' + noteText + '</div>';
                } else {
                    choicesHTML+='<div style="font-style: italic">* ' + noteText + '</div>';
                }
            }
        } else {
            choicesHTML+='</div>';
        }
        
        choicesHTML+='</div>';

        $('.question-choices').hide();
        $('.result-main').html(choicesHTML);
        $('.answers-list').html(answersHTML);

        $('.answers-summary').show();


        $('#currentQstn').val(resultSKU.id);

        if($('#currentQstn').val() == "1") {
            $('.install-modal-nav .back').css("opacity", "0");
            $('.install-modal-nav .back').css("cursor", "default");
        } else {
            $('.install-modal-nav .back').css("opacity", "1");
            $('.install-modal-nav .back').css("cursor", "pointer");
        }

        hideNext();
        disableNext();

    }

    function searchSKUAjaxCall(searchSKU) {
		return $.ajax({
			url: "/search/suggest.json?q=" + searchSKU + "&resources[type]=product&resources[options][fields]=title,variants.sku" ,
			async: false,
			data: JSON
		});
	}

	function getProductBySKU(searchSKU) {
		return new Promise(resolve => {
			searchSKUAjaxCall(searchSKU).done(function (data) {
				var searchProds = data.resources.results.products;
				var appCount = 0;

				var searchProdInstall = '';
				var searchProdNA = '';
				if ( searchProds.length > 0 ) {
					for (var i = 0; i < searchProds.length; i++) {
						var searchProd = searchProds[i];

						if ( searchProd.tags.indexOf('menu 1:Appliances') !== -1 && searchProd.tags.indexOf('menu 3:Parts and Accessories') == -1 ) {
							appCount++;
						} else {
							continue;
						}

						var installType = '';
						switch (searchProd.type) {
						case 'Dishwasher':
							if ( searchProd.tags.indexOf('dishwasher type:Portable') == -1 ) {
								installType = 'Dishwasher';
							}
							break;
						case 'Over-the-Range Microwave':
							installType = 'Over-the-Range Microwave';
							break;
						case 'Electric Wall Oven':
							if ( searchProd.tags.indexOf('microwave type:Wall Oven Combination') !== -1 ) {
								installType = 'Wall Oven MW Combination';
							} else {
								installType = 'Electric Wall Oven';
							}
							break;
						case 'Double Wall Oven':
							if ( searchProd.tags.indexOf('microwave type:Wall Oven Combination') !== -1 ) {
								installType = 'Wall Oven MW Combination';
							} else {
								installType = 'Double Wall Oven';
							}
							break;
						case 'Electric Cooktop':
							installType = 'Electric Cooktop';
							break;
						case 'Gas Cooktop':
							installType = 'Gas Cooktop';
							break;
						case 'Gas Range':
							installType = 'Gas Range';
							break;
						case 'Dryer':
							if ( searchProd.tags.indexOf('fuel type:Gas') !== -1 ) {
								installType = 'Gas Dryer';
							}
							if ( searchProd.tags.indexOf('fuel type:Electric') !== -1 ) {
								installType = 'Electric Dryer';
							}
							break;
						case 'Washer':
							installType = 'Washer';
							break;
						case 'Laundry Set':
							if ( searchProd.tags.indexOf('fuel type:Gas') !== -1 ) {
								installType = 'Laundry Set Gas';
							}
							if ( searchProd.tags.indexOf('fuel type:Electric') !== -1 ) {
								installType = 'Laundry Set Electric';
							}
							break;
						case 'Range Hood':
							if ( searchProd.tags.indexOf('install:basicfan') !== -1 ) {
								installType = 'Under Cabinet Range Hood';
							}
							if ( searchProd.tags.indexOf('install:chimney') !== -1 ) {
								installType = 'Chimney Island Range Hood';
							}
							break;
						case 'Refrigerator':
							if ( searchProd.tags.indexOf('app feature:Exterior Water Dispenser') !== -1 || searchProd.tags.indexOf('app feature:Exterior Ice Dispenser') !== -1 || searchProd.tags.indexOf('app feature:Exterior Ice/Water Dispenser') !== -1 || searchProd.tags.indexOf('app feature:Ice Maker') !== -1 || searchProd.tags.indexOf('app feature:Interior Water Dispenser') !== -1 ) {
								installType = 'Refrigerator Built In';
							}
							break;
						case 'Beverage Centre':
							if ( searchProd.tags.indexOf('app feature:Ice Maker') !== -1 ) {
								installType = 'Refrigerator External';
							}
							break;
						}
						
						var searchProdRender = ''
						if ( installType !== '' ) {
							searchProdRender = '<li class="searchProd" data-install-type="'+ installType +'">'
						} else {
							searchProdRender = '<li class="searchProd noInstall">'
						}
						searchProdRender = searchProdRender + '<div class="imgWrapper"><img src="'+ searchProd.featured_image.url.replace('.jpg', '_100x.jpg').replace('.png', '_100x.png') +'"></div>'
						searchProdRender = searchProdRender + '<p>'+ searchProd.title.split('|')[langNum].trim() +'</p></li>'
						
						if ( installType !== '' ) {
							searchProdInstall = searchProdInstall + searchProdRender;							
						} else {
							searchProdNA = searchProdNA + searchProdRender;
						}
					}
				}

				if ( appCount == 0 ) {
					//no appliances - show error message
					if ( langNum == 0 ) {
						
                        
                        $('#searchBySkuResults').html(`<div class="searchERR">
							<i class="fa fa-exclamation-circle"></i>&nbsp;No appliances found for "`+ searchSKU +`"
						</div>`);
					} else {
						$('#searchBySkuResults').html(`<div class="searchERR">
							<i class="fa fa-exclamation-circle"></i>&nbsp;Aucun électroménager trouvé pour « `+ searchSKU +` »
						</div>`);
					}
				} else {
					$('#searchBySkuResults').html(`<ul class="searchList">`+ searchProdInstall + searchProdNA +`</ul>`);
				}

			}).fail(function () {
				console.log("[Install]: Error searching for sku");
			});
			resolve('resolved');
        });
	}

    function formatCurrency(num, space) {
		num = num.toFixed(2);
		if (typeof space == "undefined" || space == true) {
			space = ' ';
		} else {
			space = '';
		}

		if (langNum == 0) {
			return '$' + space + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'); //regex function that formats numbers from 1234.56 to 1,234.56
		} else {
			return num.toString().replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ' $'; //regex function that converts numbers from 1234.56 to 1 234,56 format
		}
	};
      

    function getJSONCached(url, type='json', func){
        if( productsLibrary[url] === undefined ) {
            productsLibrary[url] = {'avail': false, 'data': null};
            (type=='json'?$.getJSON:$.get)(url, function(product) {
                productsLibrary[url] = {'avail': true, 'data': product};
                func( product );
                if( waitingList[url] !== undefined ) {
                    $.each(waitingList[url], function(i) {
                        if( waitingList[url][i]['status'] ) {
                            waitingList[url][i]['status'] = false;
                            waitingList[url][i]['func']( product );
                        }
                    });                     
                }   
            });
        }
        else {
            if( productsLibrary[url].avail ) {
                func( productsLibrary[url].data )
            }
            else {
                if( waitingList[url] === undefined ) waitingList[url] = [];
                waitingList[url].push( {'func':func, 'status':true} )
            }
        } 
    }

}